export default function EventsWedding() {
  return (
    <>
      <div className="container-fluid">
        <div className="row bg-[#d0ecf1]">
          <div className="col-md-12 pt-5 pb-3 text-center">
            <h2 className="text-uppercase g-book ft-17 border-bottom px-0 text-xl md:text-2xl px-sm-3 border-color-dark mx-auto pb-2">
              Event planning
            </h2>
            <h4 className="heading-fonts ft-34 text-uppercase mt-3 col-12 col-md-10 col-lg-6 mx-auto mb-3">
              LET US HELP ORGANIZE YOUR SPECIAL DAY
            </h4>
          </div>
          <div className="container my-3">
            <div className="row p-md-5 p-3">
              <div className=" col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Floral-Arrangement.svg"
                  className="mb-0 mb-md-3"
                  alt="Flower Arrangement"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Flower Arrangement
                </span>
              </div>
              <div className="col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Catering.svg"
                  className="mb-0 mb-md-3"
                  alt="Catering"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Catering
                </span>
              </div>
              <div className="col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Wedding-Cake.svg"
                  className="mb-0 mb-md-3"
                  alt="Wedding Cakes"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Cakes
                </span>
              </div>
              <div className="col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Car-Rental.svg"
                  className="mb-0 mb-md-3"
                  alt="Car Rental"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Cab Service
                </span>
              </div>
              <div className="col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Accomodation.svg"
                  className="mb-0 mb-md-3"
                  alt="Accommodation"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Accommodation
                </span>
              </div>
              <div className="col-6 col-sm-2 align-items-center d-flex flex-column  svg-img">
                <img
                  src="assets/Photography.svg"
                  className="mb-0 mb-md-3"
                  alt="Photography"
                />
                <span className="g-light text-uppercase d-block mb-3 mb-sm-0">
                  Photography
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
